export default "__VITE_ASSET__DAcYYifK__"